import Vue from 'vue'
import Router from 'vue-router'
import HomePC from './views/HomePC/Index.vue'
import HomeMobile from './views/HomeMobile/Index.vue'
import Live from './views/Live/Index.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HomePC',
      component: HomePC
    },
    {
      path: '/home',
      name: 'HomeMobile',
      component: HomeMobile
    },
    {
      path: '/live',
      name: 'Live',
      component: Live
    }
  ]
})
